import Button from "@components/base/button";
import { useRef, useEffect } from "react";

const DynamicDropdown = ({
  isOpen,
  onToggle,
  onClose,
  icon,
  buttonLabel,
  options,
  onSelect,
  buttonId,
  // New props for your use case
  disabled = false,
  tooltipConfig,
  upgradeIcon,
  buttonClassName = "",
  dropdownClassName = "",
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) onClose();
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  const handleToggle = () => {
    if (disabled) return;
    onToggle();
  };

  const handleOptionSelect = (item) => {
    // Call the item's callback function if it exists
    if (item.cb) {
      item.cb();
    }
    // Also call the onSelect prop if provided
    if (onSelect) {
      onSelect(item);
    }
    onClose();
  };

  return (
    <div className="tw-relative" ref={dropdownRef}>
      {/* Tooltip wrapper if tooltipConfig is provided */}
      {tooltipConfig ? (
        <span className="tw-relative" data-for={tooltipConfig.id} data-tip={tooltipConfig.message}>
          <Button variant="secondaryWithIcon" size="small" className={`tw-font-medium tw-text-sm tw-flex tw-h-8 tw-items-center disabled:tw-cursor-not-allowed ${buttonClassName} ${disabled ? "tw-opacity-50" : ""}`} onClick={handleToggle} id={buttonId} disabled={disabled}>
            {icon.before && <span className="material-symbols-outlined">{isOpen ? icon.onOpen : icon.onClose}</span>}
            <span className="ml-1">
              {buttonLabel}
              {upgradeIcon && <img src={upgradeIcon} alt="..." className="img-fluid mr-1" />}
            </span>
            {icon.after && <span className="material-symbols-outlined">{isOpen ? icon.onOpen : icon.onClose}</span>}
          </Button>
        </span>
      ) : (
        <Button variant="secondaryWithIcon" size="small" className={`tw-font-medium tw-text-sm tw-flex tw-h-8 tw-items-center disabled:tw-cursor-not-allowed ${buttonClassName} ${disabled ? "tw-opacity-50" : ""}`} onClick={handleToggle} id={buttonId} disabled={disabled}>
          {icon.before && <span className="material-symbols-outlined">{isOpen ? icon.onOpen : icon.onClose}</span>}
          <span className="ml-1">
            {buttonLabel}
            {upgradeIcon && <img src={upgradeIcon} alt="..." className="img-fluid mr-1" />}
          </span>
          {icon.after && <span className="material-symbols-outlined">{isOpen ? icon.onOpen : icon.onClose}</span>}
        </Button>
      )}

      {isOpen && !disabled && (
        <div className={`tw-flex tw-flex-col tw-shadow-button tw-px-1 tw-py-1.5 tw-gap-1 tw-left-0 tw-bg-white tw-z-[1] tw-text-sm tw-font-medium tw-absolute tw-top-10 tw-rounded tw-border tw-border-gray-200 tw-min-w-[164px] ${dropdownClassName}`}>
          {options.map((item, index) => (
            <span key={item.value || item.name || index} className="tw-px-2 tw-py-1 tw-rounded hover:tw-bg-[#f1e6fe] tw-cursor-pointer" onClick={() => handleOptionSelect(item)}>
              {item.label || item.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default DynamicDropdown;
